import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Authorization } from 'utils'
import StyleSheet from 'styles'
import { DealSheetActions, RatesActions, SnackbarActions } from 'actionsets'
import Dependent from 'containers/shared/Dependent'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import { CenteredContent } from 'containers'
import { AllocationsList, NominationsList, Admin, DealInfo } from './'
import { Summary } from 'components/deal_sheet'
import { humanize } from 'utils'

export class Management extends Component{

  constructor(props){
    super(props)
    DealSheetActions.bindActions(this)
    RatesActions.bindActions(this, 'rates')
    SnackbarActions.bindActions(this, 'snackbar')
  }

  dependsOn(){
    this.actions.rates.index()
    return (!this.unauthorised && this.editMode) ? Promise.all([
      this.actions.show({id: this.dealSheetId}),
    ]) : Promise.resolve(true)
  }

  dependenciesMet(){
    if(this.unauthorised)
      return true
    return this.editMode ? this.dealSheet.id : true
  }

  get unauthorised(){
    return (
      this.dealSheet.id &&
      this.editMode &&
      !Authorization.admin &&
      `${(this.dealSheet.issuerAccount || {}).userId}` !== `${Authorization.user.id}`
    )
  }

  get onHiddenTab(){
    return !this.showTabs && this.selectedTab !== 'deal_info'
  }

  get showTabs(){
    return this.editMode && !['draft', 'rejected'].includes(this.dealSheet.status)
  }

  get dealSheet(){
    return this.props.dealSheet
  }

  get selectedTab(){
    return this.props.match.params.tab
  }

  get dealSheetId(){
    return this.props.match.params.id
  }

  get editMode(){
    return !!this.dealSheetId
  }

  get createMode(){
    return !!this.editMode
  }

  get currencyPrice() {
    const rate = (this.dealSheet.currency) ? this.props.rates[this.dealSheet.currency.code] : null
    return rate && rate.rate
  }

  get isProduct() {
    return this.props.dealSheet.typeOfIssuance === 'product'
  }

  get nominationName() {
    return this.isProduct ? 'RFQs' : 'Nominations'
  }

  get allocationName() {
    return this.isProduct ? 'Quotes' : 'Allocation'
  }

  previewDealSheet = () => {
    this.props.history.push(`/deal_sheets/${this.props.dealSheet.id}/view`)
  }

  publishDealSheet = async() => {
    try {
      await this.actions.createEvent(this.props.dealSheet.id, { name: 'publish' })
      this.actions.snackbar.show("Deal sheet published")
    }
    catch(ex) {
      let error = "Deal sheet could not be published"
      if (ex && ex.meta && Object.keys(ex.meta).length > 0) {
        const metaKey = Object.keys(ex.meta)[0]
        error = `${humanize(metaKey)} ${ex.meta[metaKey]}`
      }
      this.actions.snackbar.error(error)
    }
  }

  get shouldShowAllocations(){
    return this.editMode && ['approved', 'published', 'active', 'closed'].includes(this.dealSheet.status)
  }

  handleTabChange = (event, selectedTab) => {
    this.props.history.push(this.editMode ?
      `/deal_sheets/${this.dealSheetId}/${selectedTab}` :
      `/deal_sheets/new/${selectedTab}`)
  }

  renderManagement = () => {
    return (
      <CenteredContent>
        {this.editMode ?
          <Typography variant='h5'>{this.dealSheet.name || 'New Deal'}{this.dealSheet.ticker && `(${this.dealSheet.ticker})`}</Typography>
          :
          <Typography variant='h5'>Dealsheet</Typography>
        }
        {this.showTabs &&
          <AppBar position="static" color="inherit" className={styles.tabBar}>
            <Tabs value={this.selectedTab} onChange={this.handleTabChange} variant='scrollable' scrollButtons="off">
              <Tab value='summary' label="Summary"/>
              <Tab value='deal_info' label="Deal Info"/>
              {
                this.shouldShowAllocations &&
                <Tab value='allocations_tab' label={this.allocationName}/>
              }
              <Tab value='nominations' label={this.nominationName}/>
              {Authorization.admin && this.dealSheet.status !== 'pending_review' &&
                <Tab value='admin' label="Admin"/>
              }
            </Tabs>
          </AppBar>
        }
        <div className={styles.tabContent}>
          {this.editMode && this.selectedTab === 'summary'    && <Summary dealSheet={this.dealSheet} onPreview={this.previewDealSheet} onPublish={this.publishDealSheet} currencyPrice={this.currencyPrice}/>}
          {this.selectedTab === 'deal_info'  && <DealInfo/>}
          {this.shouldShowAllocations && this.selectedTab === 'allocations_tab' && <AllocationsList dealSheet={this.dealSheet}/>}
          {this.editMode && this.selectedTab === 'nominations'     && <NominationsList dealSheet={this.dealSheet}/>}
          {this.editMode && this.selectedTab === 'admin'      && Authorization.admin && <Admin dealSheet={this.dealSheet} errors={this.props.errors}/>}
        </div>
      </CenteredContent>
    )
  }

  render = () => {
    switch(true){
    case this.unauthorised:
      return <Redirect to={`/deal_sheets/${this.dealSheetId}/view`}/>
    case this.onHiddenTab:
      return <Redirect to={`/deal_sheets/${this.dealSheetId}/deal_info`}/>
    default:
      return this.renderManagement()
    }
  }
}

const styles = StyleSheet({
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
  },
  tabBar: {
    marginBottom: 50,
    '@media print': {
      marginBottom: 0,
    }
  },
  tabContent: {},
})

export default connect(({dealSheets, rates}) => ({...dealSheets, ...rates}))(Dependent({loader: true, wrapperClassName: styles.wrapper})(Management))